import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card border-0 shadow-none rounded-3 mb-4 settings-card" }
const _hoisted_2 = { class: "card-body p-4 p-xl-40" }
const _hoisted_3 = { class: "d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4" }
const _hoisted_4 = { class: "settings-chip" }
const _hoisted_5 = { class: "mb-2 text-title fw-semibold mt-3" }
const _hoisted_6 = { class: "text-optional mb-0 settings-subtitle" }
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "row g-3" }
const _hoisted_10 = { class: "receipt-option" }
const _hoisted_11 = { class: "receipt-option-title" }
const _hoisted_12 = { class: "receipt-option-text" }
const _hoisted_13 = ["checked", "onChange"]
const _hoisted_14 = { class: "col-lg-4" }
const _hoisted_15 = { class: "receipt-preview-box" }
const _hoisted_16 = { class: "receipt-preview-title" }
const _hoisted_17 = { class: "receipt-preview-list" }
const _hoisted_18 = { class: "col-12" }
const _hoisted_19 = { class: "settings-label" }
const _hoisted_20 = ["value", "placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("system_settings_page.receipt_rules")), 1),
          _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$t("system_settings_page.pos_receipt_settings_title")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("system_settings_page.pos_receipt_settings_description")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiptOptions, (option) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.key,
                class: "col-md-6"
              }, [
                _createElementVNode("label", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(option.label), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(option.description), 1)
                  ]),
                  _createElementVNode("input", {
                    checked: Boolean(_ctx.settings[option.key]),
                    class: "form-check-input receipt-check",
                    type: "checkbox",
                    onChange: ($event: any) => (_ctx.patchSettings({ [option.key]: ($event.target as HTMLInputElement).checked } as Partial<Setting>))
                  }, null, 40, _hoisted_13)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("system_settings_page.receipt_preview_title")), 1),
            _createElementVNode("ul", _hoisted_17, [
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("system_settings_page.receipt_preview_item_pos")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("system_settings_page.receipt_preview_item_sales")), 1),
              _createElementVNode("li", null, _toDisplayString(_ctx.$t("system_settings_page.receipt_preview_item_branding")), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("system_settings_page.note_to_customer")), 1),
          _createElementVNode("textarea", {
            value: _ctx.settings.receipt_note_to_customer,
            rows: "3",
            class: "form-control settings-input settings-textarea",
            placeholder: _ctx.$t('system_settings_page.note_to_customer_placeholder'),
            disabled: !_ctx.settings.receipt_show_note_to_customer,
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.patchSettings({ receipt_note_to_customer: ($event.target as HTMLTextAreaElement).value })))
          }, null, 40, _hoisted_20)
        ])
      ])
    ])
  ]))
}